import React, { useState } from 'react';

import BottomSheet from 'components/ConfirmBottomSheet';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { AirlineResponse } from 'models/airlineException';

import { StyledList, Item, AirlineInfo, AirlineLogo, AirlineName, DeleteButton } from './styles';

interface Props {
  airlines: AirlineResponse[];
  onDelete: (airlineId: string) => void;
}

const ListView = ({ airlines, onDelete }: Props) => {
  const [show, setIsShow] = useState(false);
  const [id, setId] = useState('');
  const { t } = useStoreTranslation();

  const handleShow = (id: string) => {
    setIsShow(true);
    setId(id);
  };

  const handleClose = () => {
    setIsShow(false);
    setId('');
  };

  const handleConfirm = () => {
    setIsShow(false);
    onDelete(id);
    setId('');
  };

  return (
    <>
      <StyledList>
        {airlines.map((airline) => (
          <Item key={airline.id}>
            <AirlineInfo>
              <AirlineLogo airline={airline.code} />
              <AirlineName>{airline.name}</AirlineName>
            </AirlineInfo>
            <DeleteButton onClick={() => handleShow(airline.id)}>
              <img src="/corporate/images/trash.svg" alt="trash" />
            </DeleteButton>
          </Item>
        ))}
      </StyledList>
      <BottomSheet
        show={show}
        title={t('airlineException.modalDeleteTitle')}
        content={t('airlineException.modalDeleteMessage')}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default ListView;
